module.exports = require('./lib/itype');
